import { GetPermissionList } from "pages/Transactions/Transaction/TransactionController";


export const PaymentRuleValidation = async (RuleList, menuCode, TotalPayValue) => {
    const parsedNetAmount = parseFloat(TotalPayValue);
    const buildRuleList = [];

    await Promise.all(RuleList.map(async (rule) => {
        try {
            const permission = await GetPermissionList(`${menuCode}-${rule.intID}`);

            if (!permission.strMenuAccessRight) {
                if (rule.strMode === "H") {
                    const validationResponse = await HEDRuleBuilder(rule, menuCode, parsedNetAmount);
                    if (validationResponse) {
                        buildRuleList.push(validationResponse);
                    }
                }
            }
        } catch (error) {
            console.error(`Error checking permission for rule ${rule.intID}:`, error);
        }
    }));

    return buildRuleList;
};

const HEDRuleBuilder = async (RuleObject, menuCode, netAmount) => {
    try {

        let rule = RuleObject.strRule.replaceAll("HED_TOTAMOUNT", netAmount);

        if (eval(rule)) {
            return {
                strRA_TXN_TYPE: "",
                strRA_TXN_NO: "NAN",
                strRA_TXN_LOCATION: "",
                dtRA_TXN_DATE: new Date(),
                dcRA_TXN_VALUE: netAmount,
                strRA_TXN_PERMISSION: `${menuCode}-${RuleObject.intID}`,
                strRA_REQUEST: RuleDescBuilder(RuleObject.strCheckingDesc, netAmount),
                intRA_PRIORITY: RuleObject.intPriority,
                shrtRA_APPROVED: 0,
                strRA_APPROVED_BY: "",
                strRA_REMARKS: "",
            };
        }

    } catch (error) {
        console.error(`Error in HEDRuleBuilder for rule ${RuleObject.intID}:`, error);
    }

    return null;
};

// const safeEval = (expression) => {
//     try {
//         return evaluate(expression);
//     } catch (error) {
//         console.error(`Error evaluating expression "${expression}":`, error);
//         return false;
//     }
// };

const RuleDescBuilder = (rule, netAmount) => {
    if (rule.includes("HED_TOTAMOUNT")) {
        rule = rule.replaceAll("HED_TOTAMOUNT", netAmount);
    }
    return rule;
}